import React from 'react';
import Card from 'src/components/sharedComponents/Card/Card';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import CardIcon from 'src/components/sharedComponents/Card/CardIcon';
import {
  Box,
  Radio,
  Typography,
  RadioGroup,
  IconButton,
  CardActions,
  Tooltip,
  FormControlLabel,
} from '@material-ui/core';
import { Edit, Archive, Unarchive } from '@material-ui/icons';
import { useStyles, Description } from './styles';

const NewEntriesCard = (props) => {
  const {
    entry, units, onOpenEdit, handleChange, onClickArchive, onClickUnarchive,
  } = props;
  const classes = useStyles();
  const chooseFn = entry.estado === '0' || entry.estado === '4' ? onClickArchive : onClickUnarchive;

  return (
    <Card>
      <CardHeader color="customAuteco" stats icon>
        <CardIcon className={classes.cardHeader} color="customAuteco">
          <Typography className={classes.description}>
            {entry.asunto}
          </Typography>
        </CardIcon>
      </CardHeader>
      <CardBody className={classes.cardBody}>
        <Description>{entry.cuerpo}</Description>

        <Box className={classes.dateContainer}>
          <Typography className={classes.date}>
            {entry.fecha_recepcion.slice(0, 10)}
          </Typography>

          <Typography className={classes.date}>{entry.remitente}</Typography>
        </Box>
      </CardBody>

      {entry.motivo_rechazo ? (
        <CardBody>
          <Box className={classes.rejectContainer}>
            <Typography className={classes.rejectTitle}>
              Motivo del rechazo:
            </Typography>
            <Typography className={classes.rejectDescription}>
              {entry.motivo_rechazo}
            </Typography>
          </Box>
        </CardBody>
      ) : null}
      <CardActions className={classes.cardAction}>
        <RadioGroup
          value={entry.unidad || ''}
          className={classes.radioGroup}
          row
          onChange={handleChange}
        >
          {units.map((unit) => (
            <FormControlLabel
              key={unit.id}
              disabled={entry.estado === '1'}
              value={unit.id}
              control={
                <Radio style={{ color: '#FFA500' }} name={unit.unidad} />
              }
              label={unit.unidad}
            />
          ))}
        </RadioGroup>
        <IconButton onClick={onOpenEdit} disabled={entry.estado === '1'}>
          <Tooltip title="Editar">
            <Edit />
          </Tooltip>
        </IconButton>
        <IconButton onClick={chooseFn}>
          {entry.estado === '0' || entry.estado === '4' ? (
            <Tooltip title="Archivar">
              <Archive style={{ color: 'red' }} />
            </Tooltip>
          ) : (
            <Tooltip title="Desarchivar">
              <Unarchive style={{ color: 'green' }} />
            </Tooltip>
          )}
        </IconButton>
      </CardActions>
    </Card>
  );
};

export default NewEntriesCard;
